import styled from 'styled-components/native';

export const Container = styled.View`
    border: solid transparent 0.5px;
    border-top-color: #dfdfdf;
    margin-bottom: 15px;
`;
